"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceEmailsInString = exports.isString = exports.isEmptyString = void 0;
var isString = exports.isString = function isString(val) {
  return typeof val === 'string';
};
var isEmptyString = exports.isEmptyString = function isEmptyString(val) {
  return typeof val !== 'string' || val.trim().length === 0;
};

// Replaces emails with a placeholder to avoid PII leakage in logs
var replaceEmailsInString = exports.replaceEmailsInString = function replaceEmailsInString(input) {
  var replacement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'given_email';
  if (!isString(input)) return input;
  var emailRegex = /[\w.+-]+@[\w-]+\.[\w.-]+/g;
  return input.replace(emailRegex, replacement);
};